<template>
  <div>
    <div class="top-img"><img src="../assets/img/WechatIMG51.png" alt=""></div>
    <div class="text">
      <p>恭喜你成功完成【{{ prId }}】{{ title }}！</p>
      <p>成功回答以下问卷即<span class="shrink">获得额外奖励啦！</span></p>
    </div>
    <div class="btn" @click="onTapEntryBtn">进入问卷</div>
    <div class="index-content">
      <div class="index-img">
        <img src="../assets/img/WechatIMG52.png" alt="">
        <p class="title">+1元现金</p>
        <p class="sub-title">【{{ prId }}】</p>
        <p class="sub-title">奖励金+1元</p>
      </div>
      <div class="index-img">
        <img src="../assets/img/WechatIMG53.png" alt="">
        <p class="title">+2元</p>
        <p class="sub-title">2元奖励金</p>
        <p class="sub-title">即刻到账</p>
      </div>
      <div class="index-img">
        <img src="../assets/img/WechatIMG50.png" alt="">
        <p class="title">+提现加速</p>
        <p class="sub-title">【{{ prId }}】奖励金</p>
        <p class="sub-title">隔日到账</p>
      </div>
    </div>
    <div class="ps-txt">注：回答此问卷最终看到“恭喜！完成啦！”的页面，将获得本次奖励。</div>
  </div>
</template>

<script>
import { getCookie } from '../utils';

export default {
  data() {
    return {
      prId: '',
      title: '',
    }
  },

  mounted() {
    // this.prId = this.$route.query.prId
    this.prId = localStorage.getItem('cashPrId');
    this.getCashDetail();
    localStorage.removeItem('cashPrId');
  },  

  methods: {
    // 获取标题数据
    getCashDetail() {
      let unionId = getCookie('unionId');
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/questionnairedetail/getCompletedListForPc', { params: { param: unionId, pid: this.prId}}).then(res => {
        console.log(res);
        this.title = res.data.data.prTitle;
      })
    },
    // 进入问卷
    onTapEntryBtn() {
      let unionId = getCookie('unionId');
      let params =  { param: unionId, pid: this.prId }
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/distrionwj/getSsiQuestionnaireForPc', { params }).then(res => {
          // window.open(res.data.data.link);
          window.location.href = res.data.data.link;
      })
    }
  }
}
</script>

<style scoped>
div.btn {
  width: 220px;
  height: 44px;
  margin: 20px auto;
  border-radius: 4px;
  background: #66AC72;
  color: white;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  margin: 10px 20px; 
  text-align: center;
}

.text p {
  color: #999999;
  line-height: 22px;
  font-size: 12px;
}

.top-img {
  margin: 21px auto;
  text-align: center;
}

.top-img img {
  width: 222px;
  height: 57px;
}
.shrink {
  color: #66AC72;
}
.index-content {
  margin: 50px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 60%;
}

.index-img {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index-img img {
  width: 98px;
  height: 25px;
}

.index-img .title {
  font-size: 12px;
  color: #666666;
  font-weight: bold;
  margin: 10px auto;
}

.index-img .sub-title {
  font-size: 12px;
  color: #999999;
  line-height: 18px;
}

.ps-txt {
  font-size: 10px;
  color: #999999;
  text-align: center;
  line-height: 16px;
  margin-bottom: 80px;
}

.dd {
  background: #FFDB55;
  background: #E2ECF1;
}
</style>
